export const LIST_TYPE_ROAD = [
    { id: 'AV', value: 'AV', text: 'Av', label: 'Av.' },
    { id: 'CL', value: 'CL', text: 'Cl', label: 'Cl.' },
    { id: 'JR', value: 'JR', text: 'Jr', label: 'Jr.' },
];